import script from "./PageHeaderCtasBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderCtasBox.vue?vue&type=script&setup=true&lang=js"

import "./PageHeaderCtasBox.vue?vue&type=style&index=0&id=dcdc938c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcdc938c"]])

export default __exports__